import {
  Alert,
  Alignment,
  Button,
  Classes,
  Dialog,
  FormGroup,
  HTMLSelect,
  NonIdealState,
  Switch,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import {
  IEmpresa,
  ILogPgdas,
  ILogPgdasArquivos,
  ISefipArquivos,
  ITransmissao,
  newEmpresa,
  newILogPgdas,
} from "../../model";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { PgdasStore } from "../../stores/pgdas/PgdasStore";
import { TransmissaoStore } from "../../stores/sefip/TransmissaoStore";
import { toast } from "react-toastify";
import { formatCnpj, getMomentFormatter } from "../../utils";
import {
  EmpresaSelect,
  filterEmpresa,
  renderEmpresa,
} from "../empresa/EmpresaSelect";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import SolicitaPgdas from "./SolicitaPgdas";
import { DateInput } from "@blueprintjs/datetime";
import MomentLocaleUtils from "react-day-picker/moment";
import IntlCurrencyInput from "react-intl-currency-input";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { AppIcon } from "../utils/AppIcon";

interface PgdasPageState {}

const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

@observer
export default class PgdasPage extends React.Component<any, PgdasPageState> {

  obs = observable({
    selectedEmpresa: newEmpresa() as IEmpresa,
    selectedEmpresaProg: newEmpresa() as IEmpresa,
    filtro: [] as ITransmissao[],
    uuid: "" as string,
    programarPgdas: false as boolean,
    competencia: "01" as string,
    errosPgdas: newILogPgdas() as ILogPgdas,
    arquivosSefip: [] as ISefipArquivos[],
    ano: "2023" as string,
    programarDas: false as boolean,
    date_prorrogacao: null as Date,
    prorrogacao: false as boolean,
    valor_adicional: "" as string,
    open_ajuda: false as boolean,
    texto_ajuda: "" as string,
  })

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("PGDAS-D");
    PgdasStore.obs.pgdas_length = 0
    PgdasStore.obs.currentPage = 1
    PgdasStore.obs.req = []
  }

  async componentDidMount() {
    // await PgdasStore.handleConsultaCredito()
    this.obs.ano = moment(new Date()).format("YYYY")
  }

  handleBuscaClick = async () => {
    if (this.obs.selectedEmpresa.cnpj == "") {
      toast.warning('Selecione uma empresa para filtrar.', {});
      return;
    }

    if (this.obs.selectedEmpresa.simples_nacional) {
      PgdasStore.obs.filtro = [];
      await PgdasStore.handleSendPagedBusca(this.obs.selectedEmpresa, PgdasStore.obs.currentPage);
      this.obs.filtro = PgdasStore.obs.filtro;
    } else {
      return;
    }
  };

  async handleChangePgdas(e) {
    if (this.obs.selectedEmpresa.cnpj === "") {
      toast.warning('Selecione uma empresa para filtrar.', {});
      return;
    }

    if (this.obs.selectedEmpresa.simples_nacional) {
      PgdasStore.obs.filtro = [];
      await PgdasStore.handleSendPagedBusca(this.obs.selectedEmpresa, PgdasStore.obs.currentPage);
      this.obs.filtro = PgdasStore.obs.filtro;
    } else {
      return;
    }
  }

  handleCloseProgramar = async () => {
    this.obs.programarPgdas = false;

    this.obs.competencia = "01"
    this.obs.ano = moment(new Date()).format("YYYY")
    this.obs.valor_adicional = "";
    this.obs.selectedEmpresaProg = newEmpresa();
  };

  handleCloseProrrogacao = async () => {
    this.obs.programarDas = false;

    this.obs.competencia = "01"
    this.obs.ano = moment(new Date()).format("YYYY")
    this.obs.selectedEmpresaProg = newEmpresa();
    this.obs.date_prorrogacao = null;
  };

  async handleGerarDas() {
    if (this.obs.selectedEmpresaProg.cnpj == "") {
      toast.warning('Selecione uma empresa.', {});
      return;
    }

    if (!this.obs.competencia) {
      toast.warning('Selecione uma competência.', {});
      return;
    }

    if (!this.obs.ano) {
      toast.warning('Selecione um ano.', {});
      return;
    }

    if (this.obs.prorrogacao) {
      if (this.obs.date_prorrogacao == null) {
        toast.warning('Selecione uma data para a consolidação.', {});
        return;
      }

      let params = {
        empresa: this.obs.selectedEmpresaProg.cnpj,
        competencia: this.obs.competencia,
        ano: this.obs.ano,
        prorrogacao: moment(this.obs.date_prorrogacao).format("DD/MM/YYYY"),
      };

      await PgdasStore.handleDas(params);

    } else {
      let params = {
        empresa: this.obs.selectedEmpresaProg.cnpj,
        competencia: this.obs.competencia,
        ano: this.obs.ano,
      };

      await PgdasStore.handleDas(params);
    }

    this.obs.programarDas = false

  }

  handleCloseTransmitir() {
    this.obs.valor_adicional = "";
    PgdasStore.obs.transmitirPgdas = false
    this.obs.ano = moment(new Date()).format("YYYY")
  }

  handleFormataReal(vl: string): string {
    let str = vl.replace("R$", "").trim().replace(",", "").replace(".", "");
    let total = str.length;
    let inicio = str.slice(0, total - 2);
    let fim = str.slice(total - 2);

    return (inicio + "." + fim);
  }
  async handleGerarExtrato() {
    if (this.obs.selectedEmpresaProg.cnpj == "") {
      toast.warning('Selecione uma empresa.', {});
      return;
    }

    if (!this.obs.competencia) {
      toast.warning('Selecione uma competência.', {});
      return;
    }
    if (!this.obs.ano) {
      toast.warning('Selecione um ano.', {});
      return;
    }
    this.obs.programarPgdas = false
    PgdasStore.handleExtrato(this.obs.selectedEmpresaProg, this.obs.competencia, this.obs.ano, this.handleFormataReal(this.obs.valor_adicional));
  }

  handleMonths() {
    return (<>
      <option value="01">Janeiro</option>
      <option value="02">Fevereiro</option>
      <option value="03">Março</option>
      <option value="04">Abril</option>
      <option value="05">Maio</option>
      <option value="06">Junho</option>
      <option value="07">Julho</option>
      <option value="08">Agosto</option>
      <option value="09">Setembro</option>
      <option value="10">Outubro</option>
      <option value="11">Novembro</option>
      <option value="12">Dezembro</option>
    </>);
  }

  handleAnos() {
    let m = moment();
    let ano = m.year() - 1;

    return (<>
      <option value={ano + 1}>{ano + 1}</option>
      <option value={ano}>{ano}</option>
    </>)

  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar"
      />
    );
  };

  // async handleChangeTab(tabId: string) {
  //   await PgdasStore.handleConsultaCredito()
  //   PgdasStore.obs.selectedTab = tabId
  // }

  handleDataProrrogacao = (val: Date) => {
    var string = val.toString();

    var dataAgora = moment().format("YYYY-MM-DD");
    var date1 = moment(string).format("YYYY-MM-DD");

    if (date1 <= dataAgora) {
      toast.warning('Você não pode selecionar uma data inferior ao dia de hoje.', {});
      this.obs.date_prorrogacao = null;
      return null

    } else {

      this.obs.date_prorrogacao = val
      return val
    }
  };

  handleOpenAjuda = (codigo) => {

    if (codigo == "[EntradaIncorreta-PGDASD-MSG_ISN_035]") {

      this.obs.texto_ajuda = "<b>Dica:</b> Importe novamente a última declaração do PGDAS-D em <b>Editar Empresa</b>. Se o problema persistir, verifique se existem itens na categoria <b>Sem Classificação</b> e certifique-se de classificá-los."

      this.obs.open_ajuda = true

    }

  }

  formatAjudaErro = (cell, row) => {

    if (row.codigo == "[EntradaIncorreta-PGDASD-MSG_ISN_035]") {

      return (<AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.handleOpenAjuda(row.codigo)} />)

    }

    return <></>

  }

  formatTexto(cell, row) {

    return <div style={{ fontSize: 11, textAlign: "justify" }}>{cell}</div>

  }


  renderData() {
    let empresaText = this.obs.selectedEmpresa.cnpj != ""
      ? `${this.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectedEmpresa.cnpj)
      })`
      : "Selecione uma empresa";

    let empresaTextProg = this.obs.selectedEmpresaProg.cnpj != ""
      ? `${this.obs.selectedEmpresaProg.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectedEmpresaProg.cnpj)
      })`
      : "Selecione uma empresa";

    const options = {
      page: 1,
      sizePerPageList: [{
        text: "20",
        value: 20,
      }, {
        text: "50",
        value: 50,
      }, {
        text: "100",
        value: 100,
      }], // you can change the dropdown list for size per page
      sizePerPage: 20, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 4, // the pagination bar size.
      prePage: "Ante", // Previous page button text
      nextPage: "Próxima", // Next page button text
      firstPage: "Início", // First page button text
      lastPage: "Última", // Last page button text
      // paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
      paginationPosition: "bottom", // default is bottom, top and both is all available
      searchField: this.createCustomSearchField
    };

    const formatDate = (cell) => {
      return moment(cell).format("DD/MM/YYYY") + " ás " +
        moment(cell).format("HH:mm");
    };

    const handleDownloadArquivo = async (row: ILogPgdasArquivos) => {
      TransmissaoStore.obs.loadingArquivo = true;
      await PgdasStore.downloadArquivo(this.obs.uuid, row.nome, row.id);
      TransmissaoStore.obs.loadingArquivo = false;

    };

    const itens = PgdasStore.obs.req?.map(i => {
      return i;
    });

    const handleViewDetalhes = async (row: ILogPgdas) => {
      this.obs.errosPgdas = row;
      PgdasStore.obs.viewDetalhes = true;
    };

    const handleViewArquivos = async (row: ILogPgdas) => {
      this.obs.arquivosSefip = await PgdasStore.consultaArquivo(row.uuid);
      this.obs.uuid = row.uuid;
      if (this.obs.arquivosSefip.length > 0) {
        PgdasStore.obs.viewArquivos = true;
      } else {
        toast.warning('Sem arquivos Disponíveis.', {});
      }
    };

    const handleDownloadAll = async () => {
      TransmissaoStore.obs.loadingArquivo = true;

      await PgdasStore.downloadArquivosAll(
        this.obs.uuid,
        this.obs.selectedEmpresa.cnpj,
        this.obs.arquivosSefip.map(value => value.nome.replace(".pdf", "")),
      );

      TransmissaoStore.obs.loadingArquivo = false;
    };
    function buttonFormatterDetalhes(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleViewDetalhes(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleViewArquivos(row)}
          >
            <img src="/images/detalhamento.png" width="18px" />
          </MDBBtn>
        </>
      );
    }
    function buttonFormatterArquivo(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            loading={TransmissaoStore.obs.loadingArquivo}
            onClick={() => handleDownloadArquivo(row)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    function statusFormatter(cell, row) {

      return getTag(row.status, row.tipo);

    }

    function handleStatusEmail(status_email) {
      switch (status_email) {
        case true: return <span className="new-tag-nav-new">Enviado</span>
        default: return <span className="new-tag-nav-error">Não Enviado</span>
      }
    }

    const statusEmail = (cell, row) => {
      switch (row.status) {
        case null: return <span className="new-tag-nav">Processando</span>
        case "Novo": return <span className="new-tag-nav">Processando</span>
        case "Processando": return <span className="new-tag-nav">Processando</span>
        case 0: return <span className="new-tag-nav">Processando</span>
        case 1: return <span className="new-tag-nav">Processando</span>
        default: return handleStatusEmail(row.status_email)
      }
    }

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <>
        <div>
          <MDBRow>
            <MDBCol xl="7" lg="7" md="7" sm="7" xs="12" data-tut="periodo">
              <MDBRow>
                <MDBCol xl="7" lg="7" md="7" sm="7" xs="6">
                  <FormGroup className="empresaSelect" label="Empresa">
                    <EmpresaSelect
                      items={EmpresaStore.sortedEmpresas.filter(x => {
                        return x.lista_rbt12 && x.simples_nacional && !x.filial;
                      })}
                      itemRenderer={renderEmpresa}
                      itemPredicate={filterEmpresa}
                      onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresa = e}
                      inputProps={{ placeholder: "Filtrar uma empresa" }}
                    >
                      <Button
                        text={empresaText}
                        rightIcon="double-caret-vertical"
                        alignText={Alignment.LEFT}
                      />
                    </EmpresaSelect>
                  </FormGroup>
                </MDBCol>

                <MDBCol md="2">
                  <MDBBtn
                    className="btnDefault btnBuscarNfe mt25"
                    onClick={() => { this.handleBuscaClick() }}
                  >
                    Buscar
                  </MDBBtn>
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>

          <MDBCol
            xl="12"
            lg="12"
            md="12"
            sm="12"
            xs="12"
            className="btns-Drop"
            data-tut="manifestacao"
          >
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => this.obs.programarPgdas = true}
              style={{ marginRight: 20 }}
            >
              Gerar Extrato
            </MDBBtn>

            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => PgdasStore.obs.transmitirPgdas = true}
              style={{ marginRight: 20 }}
            >
              Transmissão
            </MDBBtn>

            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => { this.obs.programarDas = true }}
              style={{ marginRight: 20 }}
            >
              Gerar DAS
            </MDBBtn>

          </MDBCol>

          <Dialog
            isOpen={this.obs.programarPgdas}
            onClose={() => this.handleCloseProgramar()}
            className="AlertUser"
          >
            <h2 className="titleSEFAZ">Visualizar extrato</h2>
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas.filter(x => {
                  return x.lista_rbt12 && x.simples_nacional && !x.filial;
                })}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresaProg = e}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaTextProg}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>

            <FormGroup label="Mês:" className="inputsPeriodoCalculos">
              <HTMLSelect
                value={this.obs.competencia}
                onChange={(e) => { this.obs.competencia = e.target.value }}
                disabled={false}
              >
                {this.handleMonths()}
              </HTMLSelect>
            </FormGroup>

            <FormGroup label="Ano:" className="inputsPeriodoCalculos">
              <HTMLSelect
                value={this.obs.ano}
                onChange={(e) => { this.obs.ano = e.target.value }}
                disabled={false}
              >
                {this.handleAnos()}
              </HTMLSelect>
            </FormGroup>
            <FormGroup label="Valor adicional">
              <IntlCurrencyInput
                className="form-control"
                onChange={(e: any) => { this.obs.valor_adicional = e.target.value }}
                currency="BRL"
                config={currencyConfig}
              />
            </FormGroup>

            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.handleCloseProgramar()} />
              <Button text="Baixar extrato" intent="primary" onClick={() => this.handleGerarExtrato()} />
            </div>
          </Dialog>

          <Dialog
            isOpen={this.obs.programarDas}
            onClose={() => this.handleCloseProrrogacao()}
            className="AlertUser"
          >
            <h2 className="titleSEFAZ">Gerar DAS</h2>
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas.filter(x => {
                  return x.lista_rbt12 && x.simples_nacional && !x.filial;
                })}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresaProg = e}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaTextProg}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>

            <FormGroup label="Mês:">
              <HTMLSelect
                value={this.obs.competencia}
                onChange={(e) => { this.obs.competencia = e.target.value }}
                disabled={false}
              >
                {this.handleMonths()}
              </HTMLSelect>
            </FormGroup>

            <FormGroup label="Ano:">
              <HTMLSelect
                value={this.obs.ano}
                onChange={(e) => { this.obs.ano = e.target.value }}
                disabled={false}
              >
                {this.handleAnos()}
              </HTMLSelect>
            </FormGroup>

            <div style={{ width: "47%" }}>
              <Switch
                label="Consolidar para outra data:"
                alignIndicator="right"
                innerLabel="Não"
                innerLabelChecked="Sim"
                checked={this.obs.prorrogacao}
                onChange={(e: any) => this.obs.prorrogacao = e.target.checked}
                className="select-pgdas"
              />
            </div>

            {this.obs.prorrogacao &&

              <FormGroup
                label="Data:"
              >
                <DateInput
                  {...getMomentFormatter("DD/MM/YYYY")}
                  locale="pt-br"
                  dayPickerProps={dayPickerProps}
                  placeholder="DD/MM/AAAA"
                  onChange={this.handleDataProrrogacao}
                  value={this.obs.date_prorrogacao}
                  canClearSelection
                />
              </FormGroup>

            }

            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.handleCloseProrrogacao()} />
              <Button text="Gerar" intent="primary" onClick={() => this.handleGerarDas()} />
            </div>
          </Dialog>

          <Dialog
            isOpen={PgdasStore.obs.transmitirPgdas}
            onClose={() => this.handleCloseTransmitir()}
            className="AlertUser"
          >
            <h2 className="titleSEFAZ">Transmissão</h2>
            <SolicitaPgdas />
          </Dialog>

          <Dialog
            isOpen={PgdasStore.obs.viewDetalhes}
            onClose={() => PgdasStore.obs.viewDetalhes = false}
            title="Dados Solicitações"
            className="dados-soli"
          >
            <div className={Classes.DIALOG_BODY}>
              <div style={{ marginBottom: 10 }}>
                <MDBRow>
                  <>
                    <MDBCol md="6">
                      <p><b>Empresa: </b>{this.obs.errosPgdas.nome}</p>
                      <p><b>CPF: </b>{this.obs.errosPgdas.cpf}</p>
                      <p><b>Criado: </b>{moment(this.obs.errosPgdas.data_criacao).format("DD/MM/YYYY",) + " " + moment(this.obs.errosPgdas.data_criacao).format("HH:mm",)}</p>
                      <p><b>Atualizado: </b>{moment(this.obs.errosPgdas.ultima_atualizacao).format("DD/MM/YYYY",) + " " + moment(this.obs.errosPgdas.ultima_atualizacao).format("HH:mm")}</p>
                    </MDBCol>
                    <MDBCol md="6">
                      <p><b>Competência: </b>{this.obs.errosPgdas.competencia}</p>
                      <p><b>Tipo: </b>{this.obs.errosPgdas.tipo}</p>
                      <p><b>Identificador: </b>{this.obs.errosPgdas._id}</p>
                    </MDBCol>
                    <MDBCol md="12">
                      <h3 className="titleProccess titleCnae">Logs</h3>
                      <div className="erroSitfis" style={{ padding: 10 }}>
                        <BootstrapTable data={this.obs.errosPgdas.erros}>
                          <TableHeaderColumn dataField="codigo" isKey={true} hidden width="1%">#</TableHeaderColumn>
                          <TableHeaderColumn dataFormat={this.formatTexto} dataField="texto" width="90%"></TableHeaderColumn>
                          <TableHeaderColumn dataFormat={this.formatAjudaErro} width="10%"></TableHeaderColumn>
                        </BootstrapTable>
                      </div>
                    </MDBCol>
                  </>
                </MDBRow>
              </div>
            </div>
          </Dialog>

          <Alert
            confirmButtonText="Fechar"
            isOpen={PgdasStore.obs.viewArquivos}
            onClose={() => PgdasStore.obs.viewArquivos = false}
            canOutsideClickCancel={true}
            className="AlertUser"
          >
            <h2 className="titleSEFAZ">Arquivos</h2>
            <div className="heightArquivos">
              <div style={{ marginBottom: 5, float: "right" }}>
                <Button
                  icon="download"
                  text="Download Zip"
                  loading={TransmissaoStore.obs.loadingArquivoAll}
                  className="btn-file btnDefault noMargin"
                  onClick={() => handleDownloadAll()}
                />
              </div>

              <BootstrapTable className="nomeArquivos" data={this.obs.arquivosSefip} options={options} hover>
                <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataFormat={buttonFormatterArquivo} width="8%"></TableHeaderColumn>
                <TableHeaderColumn dataField="nome" dataSort={true} width="50%">Arquivos</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </Alert>

          <LoadingModal open={TransmissaoStore.obs.loadingArquivo} onClose={() => TransmissaoStore.obs.loadingArquivo = false} title={"Baixando arquivo"} />
          <LoadingModal open={PgdasStore.obs.loading} onClose={() => PgdasStore.obs.loading = false} title={"Buscando"} />
          <LoadingModal open={PgdasStore.obs.gerando_extrato} onClose={() => PgdasStore.obs.gerando_extrato = false} title={"Gerando extrato"} />
          <LoadingModal open={PgdasStore.obs.gerando_das} onClose={() => PgdasStore.obs.gerando_das = false} title={"Gerando DAS"} />
          <LoadingModal open={PgdasStore.obs.loadingViewArquivo} onClose={() => PgdasStore.obs.loadingViewArquivo = false} title={"Abrindo arquivo"} />
          <LoadingModal open={PgdasStore.obs.transmitindo} onClose={() => PgdasStore.obs.transmitindo = false} title={"Transmitindo"} />

          <div>
            <BootstrapTable className="TableDefault" ref="table" data={itens} options={options} hover search>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="competencia" width="20%">Competência</TableHeaderColumn>
              <TableHeaderColumn dataField="tipo" dataSort={true} width="20%">Tipo</TableHeaderColumn>
              <TableHeaderColumn dataField="data_criacao" dataFormat={formatDate} width="20%">Criado</TableHeaderColumn>
              <TableHeaderColumn dataField="ultima_atualizacao" dataFormat={formatDate} width="20%">Atualizado</TableHeaderColumn>
              <TableHeaderColumn dataFormat={statusEmail} width="20%">E-mail</TableHeaderColumn>
              <TableHeaderColumn dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
              <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="15%">Detalhes</TableHeaderColumn>
            </BootstrapTable>
          </div>
          <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
            <Pager
              currentPage={PgdasStore.obs.currentPage}
              totalCount={PgdasStore.obs.pgdas_length}
              pageSize={50}
              onPageChange={value => this.handleChangePgdas(PgdasStore.obs.currentPage = value)}
            />
          </div>
        </div>

        <Dialog
          isOpen={this.obs.open_ajuda}
          onClose={() => this.obs.open_ajuda = false}
          className="dados-soli"
        >
          <div className={Classes.DIALOG_BODY}>

            <div style={{ fontSize: 12, textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: this.obs.texto_ajuda }} />

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_ajuda = false} />
            </div>
          </div>

        </Dialog>

      </>
    );
  }

  renderNonIdeal() {
    return (
      <div className="nz-non-ideal">
        <NonIdealState
          icon="box"
          title="Você não possui permissão para acessar essa página"
        />
      </div>
    );
  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    if (niveis_acesso.indexOf("l1") == -1) {

      return this.renderNonIdeal();

    } else {

      return this.renderData();

    }

  }
}
